import VerifyOneTimeCode from './VerifyOneTimeCode'

export default VerifyOneTimeCode
